import {useContext} from 'react';
import axios from 'axios';
import {useAuth} from './use-auth';
import {ambienteContext} from '../context';
// import { useEffect } from 'react';

const useAxios = () => {

    const ambiente = useContext(ambienteContext);
    
    
    const {getCredentials} = useAuth();

    const apisFunc = {};

    const getAxios = (api) => {

        const f = async () => {
            const cred = await getCredentials();
            const token = (cred.signInUserSession)? cred.signInUserSession.idToken.jwtToken: '';
            let headers = {}
            
            let url = api.url;
            
            
            if(cred.username){
                
                const contemEmpresa = url.indexOf(':empresa');

                if(contemEmpresa > 0){
                    const empresaSelecionadaStr = localStorage.getItem("["+cred.username+"].empresaSelecionada");
                    const empresaSelecionada = JSON.parse(empresaSelecionadaStr);
                    if(empresaSelecionada && empresaSelecionada.id){
                        url = url.replace(":empresa", empresaSelecionada.id);
                       
                    }
                }

                if(api.isPrivate){
                    headers = {
                        'Authorization': token
                    }
                }
            }
            
            const newAxios = axios.create({
                baseURL: url, headers
            });
            
            return newAxios;
        }

        return f;
    }
    

    ambiente.apis.forEach(api => {
        const primeiraLetra = api.nome.substr(0, 1).toUpperCase();
        const nomeSemPrimeiraLetra = api.nome.substring(1);
        apisFunc["getApi" + primeiraLetra + nomeSemPrimeiraLetra ] = getAxios(api);
    });


    return apisFunc;





}



export {useAxios};